// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"505":"4ef59470","774":"3bd2f283","787":"4dc135a2","854":"d4ef700b","858":"b971a78a","916":"8c1b9627"}[chunkId] + ".chunk.js";
};